import React, { Fragment } from 'react'
import styles from './TotalCalculator.scss'
import { Icon } from 'common/Icon'
import { contentLabel } from 'lib/styleguide/base.scss'
import { Msg, useFormatMessage, accountLevels } from 'lib/localization'
import moment from 'moment'
import cx from 'classnames'
import { FormattedMessage as T } from 'react-intl'

export const TotalCalculator = ({
  accountLevelString,
  term,
  nextBillDate,
  monthlyQuote,
  yearlyQuote,
  subscriptionCredit,
  discountLineItems,
  daysLeft,
  baseCost,
  isTrial
}) => {
  const quote = term === 'yearly' ? yearlyQuote : monthlyQuote
  const monthlySavings = term === 'yearly' ? 1 - quote / (monthlyQuote * 12) : 0
  const fm = useFormatMessage()

  return (
    <div className={styles.TotalCalculator}>
      {nextBillDate && <Fragment>
        <span>
          {accountLevelString === 'premium'
            ? <div className={styles.header}>
              <Icon i={'premium-arrow'} className={styles.premiumIcon} />
              <h3 className={cx(contentLabel, styles.text)}><Msg m={accountLevels.premium} /></h3>
            </div>
            : <div className={styles.header}>
              <Icon i={'premium-arrow'} className={styles.basicIcon} />
              <h3 className={cx(contentLabel, styles.text)}><Msg m={accountLevels.basic} /></h3>
            </div>}
        </span>
        <div className={styles.line} />

        <div className={styles.costRow}>
          {monthlyQuote > 0
            ? <T id='TotalCalculator.monthlyCost' defaultMessage='Monthly cost' />
            : <T id='TotalCalculator.yearlyCost' defaultMessage='Yearly cost' />}
          {term === 'yearly' && <Fragment>
            <span>${monthlyQuote > 0 ? Math.round(baseCost / 12 * 100) / 100 : baseCost}</span>
            {monthlyQuote > 0 && <span style={{ color: '#777', fontStyle: 'italic' }}>
              <T id='TotalCalculator.pctDiscount'
                defaultMessage='({percent}% discount)'
                values={{ percent: Math.round(monthlySavings * 100) }} />
            </span>}
          </Fragment>}
          {term !== 'yearly' && <span>${baseCost}</span>}
        </div>
        <div className={styles.line} />

        {subscriptionCredit > 0 && <span>
          <div className={cx(styles.costRow, styles.prorated)}>
            <T id='TotalCalculator.prorated' defaultMessage='Prorated adjustment' />
            <span className={styles.prorate}>-${subscriptionCredit}</span>
          </div>
          <div className={styles.prorateTerm}>({[moment(), moment().add(daysLeft, 'days')].map((d) => d.format('MMM D, YYYY')).join(' - ')})</div>
          <div className={styles.line} />
        </span>}

        {discountLineItems && discountLineItems.map((item, idx) => (
          <span key={idx}>
            <div className={cx(styles.costRow, styles.prorated)}>
              {item.name}
              <span className={styles.prorate}>-{item.discount[accountLevelString][term]}%</span>
            </div>
            <div className={styles.prorateTerm}>{item.extra}</div>
            <div className={styles.line} />
          </span>
        ))}

        <div className={cx(styles.costRow, styles.total)}>
          <T id='TotalCalculator.today' defaultMessage="Today's total" />
          <span>
            {isTrial
              ? <T id='TotalCalculator.free' defaultMessage='Free' />
              : `$${quote}`}
          </span>
        </div>
        <div className={styles.line} />

        <div className={styles.footer}>
          <div>
            <T id='TotalCalculator.renew'
              defaultMessage='Your {accountLevel} subscription will renew at a {term} rate of {rate} on <b>{date}</b>.'
              values={{
                accountLevel: fm(accountLevelString === 'premium' ? accountLevels.premium : accountLevels.basic),
                term,
                rate: `$${discountLineItems ? quote : baseCost}`,
                b: (...c) => <b>{c}</b>,
                date: nextBillDate.format('MMMM D, YYYY')
              }} />
            <br />
          </div>
          <div className={styles.policy}>
            <span>
              <T id='TotalCalculator.guarantee'
                defaultMessage='We offer a 30 day money back guarantee. {br} <a>Privacy Policy</a>'
                values={{
                  a: (...c) => <a href='https://ridewithgps.com/privacy'>{c}</a>,
                  br: <br />
                }} />
            </span>
          </div>
        </div>
      </Fragment>}
    </div>
  )
}
